import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HEFFALUMP } from 'HubStyleTokens/colors';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { WIZARD_STEP_CLASSNAME } from './FindPartnerWizard';
const StyledUIButton = styled(UIButton).withConfig({
  displayName: "FindPartnerWizardFooter__StyledUIButton",
  componentId: "sc-1w2ktvp-0"
})(["&&{width:auto;}"]);
export default function FindPartnerWizardFooter({
  disableNextButton,
  isFirstStep,
  isLastStep,
  onClickNext,
  onClickBack,
  onClickDone,
  onClickSkip
}) {
  const renderedBackButton = useMemo(() => {
    if (isFirstStep) {
      return null;
    }

    return /*#__PURE__*/_jsxs(StyledUIButton, {
      onClick: () => onClickBack(),
      use: "secondary",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "previous",
        size: "xxs"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.back"
      })]
    });
  }, [isFirstStep, onClickBack]);
  const renderedNextButton = useMemo(() => /*#__PURE__*/_jsxs(StyledUIButton, {
    disabled: disableNextButton,
    onClick: () => onClickNext(),
    use: "primary",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.next"
    }), /*#__PURE__*/_jsx(UIIcon, {
      name: "next",
      size: "xxs"
    })]
  }), [disableNextButton, onClickNext]);
  const renderedDonebutton = useMemo(() => /*#__PURE__*/_jsxs(StyledUIButton, {
    onClick: () => onClickDone(),
    use: "primary",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.done"
    }), /*#__PURE__*/_jsx(UIIcon, {
      name: "next",
      size: "xxs"
    })]
  }), [onClickDone]);
  const renderedSkipButton = useMemo(() => {
    if (isFirstStep || isLastStep) {
      return null;
    }

    return /*#__PURE__*/_jsx(StyledUIButton, {
      className: "m-right-4",
      onClick: () => {
        onClickSkip();
      },
      style: {
        color: HEFFALUMP
      },
      use: "unstyled",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.skip"
      })
    });
  }, [isFirstStep, isLastStep, onClickSkip]);
  return /*#__PURE__*/_jsx(UIDialogFooter, {
    className: WIZARD_STEP_CLASSNAME,
    align: "between",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      justify: "between",
      children: [renderedBackButton, /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "row",
        justify: "end",
        children: [renderedSkipButton, isLastStep ? renderedDonebutton : renderedNextButton]
      })]
    })
  });
}